import { Box, Typography } from "@mui/material";
import LeftMenu from "./menus/LeftMenu";
import HeaderBar from "./headers/HeaderBar";
import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";

export default function AnalyticsDesktop() {
  const { translate } = useContext(LanguageContext);

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        minHeight: "100vh",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <LeftMenu />
      <Box sx={{ flex: 1, p: 3 }}>
        <HeaderBar
          title={translate("Analytics")}
          subtitle={translate("Monitor agent usage and performance")}
        />
        <Box sx={{ mt: 3 }}>
          <Typography variant="body1" sx={{ opacity: 0.8 }}>
            {translate("AnalyticsPagePlaceholder") ||
              "Analytics and reports will be displayed here."}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
